import { Theme } from "apps/website/maps/Theme.map";

import type { FlowPage, PageRequirement } from "../shared/constants";
import type { IDirectSalesViewState } from "./types";

// Sign-up flow store TTL: local store gets cleared after this many days of inactivity
export const DIRECT_SALES_FLOW_TTL_DAYS = 30; // @TODO: to what? an hour? how do we distinguish this rule for iPad vs customer?

export enum DirectSalesFlowSlug {
  // Cat pages
  CAT_COUNT = "/sign-up/fresh/dtc",
  CAT_DETAILS = "/sign-up/fresh/dtc/cat-details",

  // User pages
  CAT_PARENT_DETAILS = "/sign-up/fresh/dtc/cat-parent-details",
  CHECKOUT = "/sign-up/fresh/dtc/checkout",

  // Pages with no validation
  RECIPES = "/sign-up/fresh/dtc/recipes",
}

export const defaultDirectSalesViewState: IDirectSalesViewState = {
  checkout: {
    // Delivery/Shipping Address Section
    showManualEntryButton: true,
    showAddressSelect: false,
    showShippingAddressFields: false,
    hasClickedFindAddress: false,
    isDeliveryComplete: false,
    hasCompletedDeliveryOnce: false,
    hasSelectedAddressFromLookup: false,
    showShippingAddressWarning: false,
    showBillingAddressFields: false,
    billingSameAsShipping: true,
    showProcessingModal: false,
    shouldTriggerPayment: false,
  },
  catParentDetails: {
    isTransitionVisible: false,
  },
};

export interface IDirectSalesPageMetadata {
  title?: string
  hideProgressSteps?: boolean
  hideFooter?: boolean
  headerBgColor?: Theme
  bgColor?: Theme
  isUserPage?: boolean
  copyCatAnswers?: boolean
  hidePromoBanner?: boolean
  promoBannerAnimateOnEntry?: boolean
  /**
   * Access requirements are used to determine if a page should be displayed to the user.
   * Example A/B test requirement
   * accessRequirements: [
        (context: FlowNavigationContext) => context.inABTestGroup("new-basic-information-flow"),
      ],
   */
  accessRequirements?: PageRequirement[]
}

export const DIRECT_SALES_FLOW_PAGES: Record<DirectSalesFlowSlug, IDirectSalesPageMetadata> = {
  [DirectSalesFlowSlug.CAT_COUNT]: {
    title: "catCount",
    bgColor: "light",
    promoBannerAnimateOnEntry: true,
  },
  [DirectSalesFlowSlug.CAT_DETAILS]: {
    title: "catDetails",
    copyCatAnswers: false,
  },
  [DirectSalesFlowSlug.CAT_PARENT_DETAILS]: {
    hideProgressSteps: true,
    bgColor: "light-grey",
    headerBgColor: "light-grey",
    isUserPage: true,
  },
  [DirectSalesFlowSlug.RECIPES]: {
    title: "recipes",
    hideProgressSteps: true,
    hidePromoBanner: true,
  },
  [DirectSalesFlowSlug.CHECKOUT]: {
    title: "checkout",
    hideProgressSteps: true,
    isUserPage: true,
    bgColor: "light",
    hidePromoBanner: true,
  },
};

export const directSalesFlowPages: FlowPage<DirectSalesFlowSlug>[] = Object.entries(DIRECT_SALES_FLOW_PAGES).map(
  ([ slug, metadata ]) => ({
    slug: slug as DirectSalesFlowSlug,
    accessRequirements: metadata.accessRequirements ?? [],
  }),
);
